module.exports = __webpack_public_path__ + "img/geofisica3_4-3_682.5409378b.webp";